import {DateWithWeekday} from 'presentation/components';
import React from 'react';
import {ProfessionalCard} from '../ProfessionalCard';
import {StyledListSubheader} from './styles';
import {ProfessionalDateSectionProps} from './types';

export const ProfessionalDateSection = React.memo(function ProfessionalDateSection({
	date,
	professionals,
	onSelectHour,
	flowType,
	query,
	shouldNotUseHighlight,
}: ProfessionalDateSectionProps) {
	if (!professionals.length) return null;

	return (
		<li>
			<ul>
				<StyledListSubheader>
					<DateWithWeekday date={date} />
				</StyledListSubheader>

				{professionals?.map(item => (
					<ProfessionalCard
						key={item.professionalCode}
						professionalCode={item.professionalCode}
						professionalName={item.professionalName}
						availableTimes={item.availableTimes}
						date={date}
						onSelectHour={onSelectHour}
						recommendations={item.recommendations}
						flowType={flowType}
						query={query}
						shouldNotUseHighlight={shouldNotUseHighlight}
						isFavorite={item.isFavorite}
					/>
				))}
			</ul>
		</li>
	);
});
